

import React from 'react';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';
import { nanoid } from 'nanoid'
import { useDispatch, useSelector } from "react-redux";
import Button from '@mui/material/Button';
import FormBuilder, { IMedAppFormField } from '../../../form';
import api from '../../../../api/medAppApi';
import LinearProgress from '@mui/material/LinearProgress';
import { putMessage } from '../../../app/store/actions';
import { Affiliate, Discount } from '../../../../models';
import { required, minLength } from '../../../form/utils/validations';
import { createModel } from '../../store/actions';
import { useQuery } from 'react-query';
import { selectCreatingModel } from '../../store/selectors';

const DiscountCreateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const DiscountCreateReduxForm = reduxForm<any, any>({
    form: 'discount-create',
})(DiscountCreateForm);


const DiscountCreate: React.FC<{
    discount?: Discount
}> = ({ discount }) => {
 const codePrepend = nanoid(6).toUpperCase();
    const dispatch = useDispatch();
    const creating = useSelector(selectCreatingModel('discount'));
   
    const {data: affiliates, isFetching: isFecthing2, isError: isError2 } = useQuery('load-affiliates', async () => {
     
        const ans2 = await api.getModelList<Affiliate>({modelName: "affiliate", returnType: "list", crieteria:
        {}, limit: 20, page: 1});
        return ans2.data!.data.payload.map(v => ({
            value: v.id,
            label: v.id + ' - ' + v.name,
        }))
      });
      React.useEffect(() => {
        if(isError2) {
         dispatch(putMessage({type: 'error', message: 'Failed to load Affiliates'}))
     }
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [isError2])

    const fields: IMedAppFormField[] = React.useMemo(() => ([
        {
            name: 'label',
            label: 'Label',
            type: 'text',
            validate: [required],

        },
        {
            name: 'code',
            label: 'Code',
            type: 'text',
            defaultValue: codePrepend,
            inputExtras: {
                placeholer: codePrepend,
            },
            validate: [required, minLength(5)],

        },
        {
            variant: 'autocomplete',
            inputExtras: !!affiliates ? affiliates : [],
            name: 'affiliate',
            label: 'Affiliate',
            validate: [required],
            type: 'text'
        },
        {
            name: 'discount',
            label: 'Discount e.g(0.2 = 20%)',
            type: 'number',
            validate: [required]
        },


 
        
    ]), [codePrepend, affiliates]);


    
    const handleSubmit = (value: any) => {
        const data = {...value, discount: Math.round(parseFloat(value.discount) * 100), affiliate: parseInt(value.affiliate.split('-')[0].trim())}
        
        dispatch(createModel({
            model: data,
            modelName: 'discount',
        }))
    }

    
    return (
        <Box style={{
            width: '100%'
        }}>
            <Box sx={{
                width: '70%',
                maxWidth: '700px',
                minWidth: '250px',
                marginLeft: '1em'
            }}>
                  {(isFecthing2 || creating) && <LinearProgress />}
                <DiscountCreateReduxForm mFields={fields} namel="kosy-2" onSubmit={handleSubmit} />
            </Box>
        </Box>
    )
};

export default DiscountCreate;